import { produce } from "immer";
import {
  SET_ONBOARD_STEP,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  UPDATE_PERIOD_INFO,
  UPDATE_PERIOD_INFO_SUCCESS,
  UPDATE_PERIOD_INFO_FAILURE,
  SET_PERMISSIONS,
  SET_PERMISSIONS_SUCCESS,
  SET_PERMISSIONS_FAILURE,
  SET_ALLOWANCE,
  SET_ALLOWANCE_SUCCESS,
  SET_ALLOWANCE_FAILURE,
  ONBOARD_EMPLOYEE,
  ONBOARD_EMPLOYEE_SUCCESS,
  ONBOARD_EMPLOYEE_FAILURE,
  SET_ONBOARDING_DATA,
  UPDATE_BASIC_INFO,
  UPDATE_BASIC_INFO_SUCCESS,
  UPDATE_BASIC_INFO_FAILURE,
  SET_ONBOARD_INFO,
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAILURE,
  SET_FILE_LIST,
  SET_ACCOUNTING_TYPE,
  UPLOAD_COMMON_DOCUMENT,
  UPLOAD_COMMON_DOCUMENT_SUCCESS,
  UPLOAD_COMMON_DOCUMENT_FAILURE,
  GET_COMMON_DOCUMENTS,
  GET_COMMON_DOCUMENTS_SUCCESS,
  GET_COMMON_DOCUMENTS_FAILURE,
  DOWNLOAD_DOC,
  DOWNLOAD_DOC_SUCCESS,
  DOWNLOAD_DOC_FAILURE,
} from "./constants";

export const initialState = {
  onboardStep: 1,
  isCreatingCustomer: false,
  onboardDocList: [],
  onboardFileList: [],
  isUploadingDocument: false,
  isUpdatingPeriodInfo: false,
  isSettingPermissions: false,
  isSettingAllowance: false,
  isOnboardingEmployee: false,
  onboardingData: null,
  isUpdatingBasicInfo: false,
  onboardingInfo: null,
  isGettingDocuments: false,
  accountingType: "employee",
  isUploadingCommonDocument: false,
  isGettingCommonDocuments: false,
  commonDocuments: [],
  isDownloadingDoc: false,
};

const OnboardingReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_ONBOARD_STEP:
        draft.onboardStep = action.payload;
        break;
      case CREATE_CUSTOMER:
        draft.isCreatingCustomer = true;
        break;
      case CREATE_CUSTOMER_SUCCESS:
        draft.isCreatingCustomer = false;
        draft.onboardDocList = action.payload.documents;
        break;
      case CREATE_CUSTOMER_FAILURE:
        draft.isCreatingCustomer = false;
        break;
      case UPLOAD_DOCUMENT:
        draft.isUploadingDocument = true;
        break;
      case UPLOAD_DOCUMENT_SUCCESS:
        draft.isUploadingDocument = false;
        break;
      case UPLOAD_DOCUMENT_FAILURE:
        draft.isUploadingDocument = false;
        break;
      case UPDATE_PERIOD_INFO:
        draft.isUpdatingPeriodInfo = true;
        break;
      case UPDATE_PERIOD_INFO_SUCCESS:
        draft.isUpdatingPeriodInfo = false;
        break;
      case UPDATE_PERIOD_INFO_FAILURE:
        draft.isUpdatingPeriodInfo = false;
        break;
      case SET_PERMISSIONS:
        draft.isSettingPermissions = true;
        break;
      case SET_PERMISSIONS_SUCCESS:
        draft.isSettingPermissions = false;
        break;
      case SET_PERMISSIONS_FAILURE:
        draft.isSettingPermissions = false;
        break;
      case SET_ALLOWANCE:
        draft.isSettingAllowance = true;
        break;
      case SET_ALLOWANCE_SUCCESS:
        draft.isSettingAllowance = false;
        break;
      case SET_ALLOWANCE_FAILURE:
        draft.isSettingAllowance = false;
        break;
      case ONBOARD_EMPLOYEE:
        draft.isOnboardingEmployee = true;
        break;
      case ONBOARD_EMPLOYEE_SUCCESS:
        draft.isOnboardingEmployee = false;
        break;
      case ONBOARD_EMPLOYEE_FAILURE:
        draft.isOnboardingEmployee = false;
        break;
      case SET_ONBOARDING_DATA:
        draft.onboardingData = action.payload;
        break;
      case UPDATE_BASIC_INFO:
        draft.isUpdatingBasicInfo = true;
        break;
      case UPDATE_BASIC_INFO_SUCCESS:
        draft.isUpdatingBasicInfo = false;
        break;
      case UPDATE_BASIC_INFO_FAILURE:
        draft.isUpdatingBasicInfo = false;
        break;
      case SET_ONBOARD_INFO:
        draft.onboardingInfo = action.payload;
        break;
      case GET_DOCUMENTS:
        draft.isGettingDocuments = true;
        break;
      case GET_DOCUMENTS_SUCCESS:
        draft.isGettingDocuments = false;
        draft.onboardDocList = action.payload.documents;
        draft.onboardFileList = action.payload.files;
        draft.onboardFormId = action.payload.form_id;
        break;
      case GET_DOCUMENTS_FAILURE:
        draft.isGettingDocuments = false;
        break;
      case SET_FILE_LIST:
        draft.onboardFileList = action.payload;
        break;
      case SET_ACCOUNTING_TYPE:
        draft.accountingType = action.payload;
        break;
      case UPLOAD_COMMON_DOCUMENT:
        draft.isUploadingCommonDocument = true;
        break;
      case UPLOAD_COMMON_DOCUMENT_SUCCESS:
        draft.isUploadingCommonDocument = false;
        break;
      case UPLOAD_COMMON_DOCUMENT_FAILURE:
        draft.isUploadingCommonDocument = false;
        break;
      case GET_COMMON_DOCUMENTS:
        draft.isGettingCommonDocuments = true;
        break;
      case GET_COMMON_DOCUMENTS_SUCCESS:
        draft.isGettingCommonDocuments = false;
        break;
      case GET_COMMON_DOCUMENTS_FAILURE:
        draft.isGettingCommonDocuments = false;
        break;
      case DOWNLOAD_DOC:
        draft.isDownloadingDoc = true;
        break;
      case DOWNLOAD_DOC_SUCCESS:
        draft.isDownloadingDoc = false;
        break;
      case DOWNLOAD_DOC_FAILURE:
        draft.isDownloadingDoc = false;
        break;
      default:
        return state;
    }
  });

export default OnboardingReducer;
